<template>

    <div>
        <div id="p-P" class="p-title w588 flex items-center justify-center">
            <img class="img-p-name" :src="luckyboxStore.getAsset('images/event/2026luckybox/W-pr-name-p3.png')" alt="好聰敏3益生菌"/>
        </div>
        <div class="box-style max-w-1250">
            <div class="product-list">
                <div class="directions-BG">
                    <a :href="luckyboxStore.getAsset('/images/event/p-p-jump.jpg')" @click.prevent="handlePopup">
                        <img class="pc-show w963" :src="luckyboxStore.getAsset('/images/event/2026luckybox/p-p-effect.png')" alt="害怕天氣變化？第三代LP-HB89，鞏固健康堡壘，體質調整更有感，跟面紙說再見！"/>
                        <img class="mo-show" :src="luckyboxStore.getAsset('/images/event/2026luckybox/mo-title-p_03.png')" alt="害怕天氣變化？第三代LP-HB89，鞏固健康堡壘，體質調整更有感，跟面紙說再見！"/>
                    </a>
                </div>

                <Placeholder v-if="!hasBundles()" :count="4" width="100%" height="300px" />

                <ul class="grid grid-1-2-4 gap-05rem" v-else>

                    <li class="product-list__item" v-for="(bundle, bid) in items" :key="bundle.id">
                        <div class="item-style">
                            <div class="gold-circle">
                                <div class="number-befor text-3xl font-semibold">{{ bundle.base_qty ?? '--' }}</div>
                            </div>
                            <div class="mo-w280">
                                <img class="margin-t25" :src="luckyboxStore.getAsset('images/event/2026luckybox/P-probiotics-01.png')" alt="好聰敏3益生菌"/>
                                <img class="m-cut-20" :src="luckyboxStore.getAsset(bundle?.cover_price)" :alt="`${toNumeric(bundle?.price)}福箱`" />
                            </div>
                            <div class="flex flex-col">
                                <div class="text-center m-bottom-05">
                                    <span class="original-P text-xl">
                                        <span class="line-through">{{ toNumeric(bundle.price_origin ?? '0' ) }}</span>
                                    </span>
                                    &ensp;
                                    <span class="average">平均<span>{{ toNumeric(bundle.price_avg) }}</span>/盒</span>
                                </div>
                                <div class="flex items-end comment-txt">※口味隨心搭</div>
                            </div>

                            <template v-for="(item, itemid, itemidx) in bundle.items" :key="itemidx">
                                <div class="flex justify-between border-style" :class="{'not-buy': !item.is_available}">
                                    <div :class="`radius-100 taste-style ${item.flavor_css}`">{{ item.flavor }}</div>
                                    <div class="flex justify-center items-center">
                                        <button class="minus-btn"
                                            :disabed="true !== item?.is_available"
                                            @click.prevent="luckyboxStore.setQty('minus', itemid, bid, item)"
                                            ></button>
                                        <span class="text-xl leading-none">{{ cart[bid]?.items[itemid] ?? 0 }}</span>
                                        <button class="plus-btn"
                                            :disabed="true !== item?.is_available"
                                            @click.prevent="luckyboxStore.setQty('plus', itemid, bid, item)"
                                            ></button>
                                    </div>
                                </div>
                            </template>

                        </div>
                        <div class="text-center" v-if="campaign?.is_active">
                            <button class="add-to-cart-btn red-btn radius-100 font-semibold"
                                :disabled="states.is_loading || !isItemAvailable(bid) || !luckyboxStore.isCartReadyForItem(bid)"
                                :class="{
                                    'not-buy': !luckyboxStore.isCartReadyForItem(bid),
                                    'not-buy adding': states.is_loading,
                                }"
                                :loading="states.is_loading"
                                @click.prevent="handleAddBundleToCart($event, bid)"
                                >
                                <span v-if="!luckyboxStore.isCartReadyForItem(bid)">先選取數量</span>
                                <span v-else-if="states.is_loading">處理中...</span>
                                <span v-else>加入購物車</span>
                            </button>
                        </div>
                    </li>


                </ul>
            </div>
        </div>
    </div>

</template>

<style lang="scss" scope>
.not-buy,
.add-to-cart-btn[disabled] {
    filter: grayscale(1);
    opacity: 0.4;
    cursor: not-allowed!important;
    pointer-events: none;
}
</style>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { toNumeric } from '../../../composables/utils';
import { useGlobalStore } from '../../../stores/useGlobalStore';
import { useLuckyboxStore } from '../../../stores/useLuckyboxStore';
import Placeholder from './placeholder.vue';

const emits = defineEmits(['popup']);

const globalStore = useGlobalStore();
const luckyboxStore = useLuckyboxStore();

const { is_loading } = storeToRefs(globalStore);
const { cart, bundles, expanded, campaign, states } = storeToRefs(luckyboxStore);

const hasBundles = () => {
    if (!items?.value) {
        return false;
    }
    return Object.keys(items.value).length > 0;
};

const items = computed(() => {
    return luckyboxStore.getBundleByType('probiotic', bundles.value) ?? [];
});

const isItemAvailable = (bid) => {
    const rows = items.value?.[bid]?.items ?? {};
    if (!rows || Object.keys(rows).length === 0) {
        return false;
    }
    return Object.values(rows).every(item => item?.is_available);
};

// 新增組合產品到購物車
const handleAddBundleToCart = async(e, bid) => {
    await luckyboxStore.addBundleToCart(bid);
};

const handlePopup = (e) => {
    const src = e.currentTarget.getAttribute('href');
    if (src) {
        emits('popup', src);
    }
};

</script>
